import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect } from 'react';
import { BKJButton } from '../BKJButton/index.js';
import { BKJDialogWrapper, Title, Text, CloseIcon, ButtonGroup, TextWrapper, CloseIconWrapper, } from './BKJDialog.styled.js';
const CancelVariantMap = {
    Danger: 'PurpleOutlined',
    Default: 'PurpleOutlined',
};
const ActionVariantMap = {
    Danger: 'RedSolid',
    Default: 'PurpleSolid',
};
export const BKJDialog = forwardRef(({ variant, title, text, cancelLabel, actionLabel, onAction, onCancel, onClose, ...rest }, ref) => {
    const handleKeyUp = useCallback((event) => {
        if (event.key === 'Escape') {
            onClose();
        }
    }, [onClose]);
    useEffect(() => {
        document.addEventListener('keyup', handleKeyUp);
        return () => {
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, [handleKeyUp]);
    return (_jsxs(BKJDialogWrapper, { ...rest, variant: variant, ref: ref, children: [_jsx(CloseIconWrapper, { onClick: onClose, role: "button", tabIndex: 0, children: _jsx(CloseIcon, { iconName: "CloseBold" }) }), _jsxs(TextWrapper, { children: [_jsx(Title, { children: title }), _jsx(Text, { children: text })] }), _jsxs(ButtonGroup, { children: [_jsx(BKJButton, { variant: CancelVariantMap[variant], onClick: onCancel, children: cancelLabel }), _jsx(BKJButton, { variant: ActionVariantMap[variant], onClick: onAction, children: actionLabel })] })] }));
});
//# sourceMappingURL=BKJDialog.js.map